import axios from "axios";
import { LoginCredetials, LoginedUser, LoginedInUserData } from "./AuthModel";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";

@Module({ namespaced: true })
class Auth extends VuexModule {
    public accessToken = localStorage.getItem('accessToken');
    public tokenId = localStorage.getItem('tokenId');
    public user = localStorage.getItem('user') as LoginedUser | null;

    @Mutation
    LOGIN(data: LoginedInUserData) {
        localStorage.setItem('user', JSON.stringify(data.user))
        localStorage.setItem('accessToken', data.access_token)
        localStorage.setItem('tokenId', data.token_id)

        this.accessToken = data.access_token
        this.tokenId = data.token_id
        this.user = data.user

        axios.defaults.headers.common["Authorization"] = "Bearer " + this.accessToken

    }

    @Mutation
    LOGOUT() {

        localStorage.setItem('user', '')
        localStorage.setItem('accessToken', '')
        localStorage.setItem('tokenId', '')

        this.accessToken = ''
        this.tokenId = ''
        this.user = null

    }



    @Action({ rawError: true })
    public async logout() {

        const promise = new Promise((resolve, reject) => {
            axios.post('api/logout', { token_id: this.tokenId })
                .then(({ data }) => {

                    this.context.commit('LOGOUT', data)
                    resolve(data)
                }, error => {
                    reject(error)
                })

        });

        return promise;

    }

    @Action({ rawError: true })
    public async login(credentials: LoginCredetials) {

        return new Promise((resolve, reject) => {

            axios.post("/api/login", credentials).then(({ data }) => {
                this.context.commit('LOGIN', data)
                resolve(data);

            }, error => {
                reject(error);
            })

        })

    }

    get authenticated(): boolean {
        if (this.user) {
            return true;
        }

        return false;
    }

    get fullName(): string {
        if (this.user?.email == undefined) {
            const toUnknown = this.user as unknown
            const userJson = toUnknown as string
            const user = JSON.parse(userJson);
            return `${user?.first_name}   ${user?.last_name}`

        }

        return `${this.user?.first_name}   ${this.user?.last_name}`
    }
}

export default Auth;
